import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import clsx from 'clsx';
import StepConnector from '@material-ui/core/StepConnector';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Check from '@material-ui/icons/Check';
var QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)'
  },
  active: {
    '& $line': {
      borderColor: '#77ffb5'
    }
  },
  completed: {
    '& $line': {
      borderColor: '#77ffb5'
    }
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1
  }
})(StepConnector);
var useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center'
  },
  active: {
    color: '#77ffb5'
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor'
  },
  completed: {
    color: '#77ffb5',
    zIndex: 1,
    fontSize: 18
  }
});

var QontoStepIcon = function QontoStepIcon(props) {
  var classes = useQontoStepIconStyles();
  var active = props.active,
      completed = props.completed;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.root, _defineProperty({}, classes.active, active))
  }, completed ? /*#__PURE__*/React.createElement(Check, {
    className: classes.completed
  }) : /*#__PURE__*/React.createElement("div", {
    className: classes.circle
  }));
};

export { QontoConnector, QontoStepIcon };